import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/user';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { io, Socket } from 'socket.io-client';
import { LoginService } from './login.service';
import { CommonService } from './common.service';
// import oboe from 'oboe';
import { SocketService } from './socket.service';
import { EncryptionDecryptionService } from './encryption-decryption.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  user: User = new User();
  constructor(
    private http: HttpClient,
    private loginService: LoginService,
    private encryptDecrypt: EncryptionDecryptionService,
    private commonService: CommonService,
    private socketService: SocketService
  ) {
    this.loginService.currentUser.subscribe((x) => (this.user = x));
  }
  socket = this.socketService.socket;
  private baseUrl = environment.baseUrl;

  ngOnInit() {
    this.socket.on('user.keys.adb.error', function (error) {
      //$rootScope.$broadcast('user.keys.adb.error', error)
    });

    this.socket.on('user.keys.adb.added', function (key) {
      this.getAdbKeys().push(key);
      //$rootScope.$broadcast('user.keys.adb.updated', user.adbKeys)
      //$rootScope.$apply()
    });

    this.socket.on('user.keys.adb.removed', function (key) {
      this.user.adbKeys = this.getAdbKeys().filter(function (someKey) {
        return someKey.fingerprint !== key.fingerprint;
      });
      //$rootScope.$broadcast('user.keys.adb.updated', user.adbKeys)
      //$rootScope.$apply()
    });

    this.socket.on('user.keys.adb.confirm', function (data) {
      this.addAdbKeyModalService.open(data).then(function (result) {
        if (result) {
          this.acceptAdbKey(data);
        }
      });
    });

    this.socket.on('user.settings.users.created', function (user) {
      //$rootScope.$broadcast('user.settings.users.created', user)
      //$rootScope.$apply()
    });

    this.socket.on('user.settings.users.deleted', function (user) {
      //$rootScope.$broadcast('user.settings.users.deleted', user)
      //$rootScope.$apply()
    });

    this.socket.on('user.view.users.updated', function (user) {
      //$rootScope.$broadcast('user.view.users.updated', user)
      //$rootScope.$apply()
    });

    this.socket.on('user.settings.users.updated', function (user) {
      //$rootScope.$broadcast('user.settings.users.updated', user)
      //$rootScope.$apply()
    });
  }

  getUser() {
    return this.http.get(`${this.baseUrl}` + '/api/v1/user');
  }

  getAdbKeys() {
    return this.user.adbKeys || (this.user.adbKeys = []);
  }

  addAdbKey(key) {
    this.socket.emit('user.keys.adb.add', key);
  }

  acceptAdbKey(key) {
    this.socket.emit('user.keys.adb.accept', key);
  }

  removeAdbKey(key) {
    this.socket.emit('user.keys.adb.remove', key);
  }

  getRecentActivities(email: any) {
    return this.http.get(
      `${this.baseUrl}` + `/api/v1/user/getRecentActivities?user=` + email
    );
  }

  getLicenseInfo(licenseId: any) {
    return this.http.get(
      `${this.baseUrl}` + `/api/v1/user/getLicenseInfo?user=` + licenseId
    );
  }

  buildQueryParameters(filters: any) {
    let query = '';

    if (filters.groupOwner !== 'Any') {
      query += 'groupOwner=' + filters.groupOwner.toLowerCase();
    }
    return query === '' ? query : '?' + query;
  }

  getOboeUsers(fields, addUser) {
    // return oboe()(this.commonService.getBaseUrl() + '/api/v1/users?fields=' + fields)
    //   .node('users[*]', function(user) {
    //     addUser(user)
    //   })
    return this.http.get(`${this.baseUrl}` + '/api/v1/users?fields=' + fields);
  }

  getUsers(fields) {
    return this.http.get(`${this.baseUrl}` + '/api/v1/users?fields=' + fields);
  }

  getUser1(email, fields) {
    return this.http.get(
      `${this.baseUrl}` + '/api/v1/users/' + email + '?fields=' + fields
    );
  }

  removeUser(email: any, filters: any) {
    return this.http.delete(
      `${this.baseUrl}` +
        '/api/v1/users/' +
        email +
        this.buildQueryParameters(filters)
    );
  }

  removeUsers(emails: any, filters: any) {
    let data =
      typeof emails === 'undefined'
        ? emails
        : JSON.stringify({ emails: emails });
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;charset=utf-8',
      }),
      body: {
        data: data,
      },
    };
    return this.http.delete(
      `${this.baseUrl}` + '/api/v1/users' + this.buildQueryParameters(filters),
      options
    );
  }

  updateUserGroupsQuotas = function (email, number, duration, repetitions) {
    let Data = {
      email: email,
      number: number,
      duration: duration,
      repetitions: repetitions,
    };
    return this.http.put(
      `${this.baseUrl}` +
        '/api/v1/users/' +
        email +
        '/groupsQuotas?number=' +
        number +
        '&duration=' +
        duration +
        '&repetitions=' +
        repetitions,
      Data
    );
  };

  updateDefaultUserGroupsQuotas = function (number, duration, repetitions) {
    let data = {
      number: number,
      duration: duration,
      repetitions: repetitions,
    };

    return this.http.put(
      `${this.baseUrl}` +
        '/api/v1/users/groupsQuotas?number=' +
        number +
        '&duration=' +
        duration +
        '&repetitions=' +
        repetitions,
      data
    );
  };

  createUser(name: any, email: any, password: any) {
    let data = {
      email: email,
      name: name,
      password: password,
    };
    return this.http.post(
      `${this.baseUrl}` + '/api/v1/users/' + email + '?name=' + name,
      data
    );
  }

  saveUser(email, password, oldPassword) {
    let data: any = {
      oldPassword: oldPassword,
      newPassword: password,
      email: email,
    };
    return this.http.get(
      `${this.baseUrl}` + 'api/v1/users/changePassword',
      data
    );
  }

  changePass(email, password, oldPassword) {
    let dataBeforeEnc: any = {
      oldPassword: oldPassword,
      newPassword: password,
      email: email,
    };
    let data: any = {
      encryptedText: this.encryptDecrypt.setEncryption(dataBeforeEnc),
    };
    return this.http.post(
      `${this.baseUrl}` + '/api/v1/users/changePassword',
      data
    );
  }

  showUserList() {
    return this.http.get(`${this.baseUrl}` + '/s/getAllUsers');
  }

  UserBlockUnblock(email: any, value: boolean): Observable<any> {
    let data = {
      email: email,
      isProfile: value,
    };

    return this.http.post(
      `${this.baseUrl}` + '/api/v1/users/profileStatus',
      data
    );
    // this.htt
  }

  // updateLastLogindate(data :any){
  //   return this.http.post(`${this.baseUrl}+/profile/updateLastlogindate`,data)

  // }
}
